import React from 'react'
import {connect} from 'react-redux'
import { LoadMore } from 'react-weui'

class NewPeopleTransfer extends React.Component {
    constructor() {
        super();
    }
    componentDidMount () {
        document.title = '新人报到大礼包'
    }
    componentWillReceiveProps(nextProps) {
        let {subscribed} = nextProps.account
        //新人报道中转页 判断是否关注 关注带参数b 未关注带参数c
        if(subscribed){
            window.location.replace('/specials/newreports?wk_from=param_b');
        }else{
            window.location.replace('/specials/newreports?wk_from=param_c');
        }

    }
    render(){
        return(
            <div style={{background:'#fff',height:'100vh'}}>
                <LoadMore loading className='wk-center'>Loading</LoadMore>
            </div>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(NewPeopleTransfer)


// WEBPACK FOOTER //
// ./src/pages/ActivityPage/NewPeopleReports/NewPeopleTransfer.js